import { render, staticRenderFns } from "./money_load.vue?vue&type=template&id=5c55e428&scoped=true&"
import script from "./money_load.vue?vue&type=script&lang=js&"
export * from "./money_load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55e428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c55e428')) {
      api.createRecord('5c55e428', component.options)
    } else {
      api.reload('5c55e428', component.options)
    }
    module.hot.accept("./money_load.vue?vue&type=template&id=5c55e428&scoped=true&", function () {
      api.rerender('5c55e428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/addon/money_load.vue"
export default component.exports